import { EmptyView, ItemListContent } from "@eusoft/webapp-framework";
import { content } from "@eusoft/webapp-ui";
import { CreateProductPage, EditProductPage } from "./EditProduct";
import { Icons } from "../../entities/Icons";
import {  merchantItemsSource, productItemsSource } from "../../helpers/ItemsSources";
import { context } from "../../services/Context";
import { executeAsync } from "../../services/DataService";
import { type IListMerchant, type IListProduct, type IProductListView } from "../../entities/Commands";
import { FilterEditor, FieldSearchMode } from "@eusoft/webapp-framework/components/FilterEditor";

export interface IListProductArgs {
}



const createFilter = () => new FilterEditor<IListProduct, IProductListView>({
    fields: {

        merchantId: {
            label: "merchant",
            color: "#9C27B0", // purple 500
            valuesSource: merchantItemsSource,
            searchMode: FieldSearchMode.Client,
            icon: Icons["merchant"],
           
            valuesFilter: a => ({
                saleCircuitId: context.saleCircuit?.id,
            } as Partial<IListMerchant>)
        }
    },
    renderMode: "field",
    matchFields: a => [a.name],
    queryField: "query",
});



async function deleteItemAsync(item: IProductListView) {

    const res = await executeAsync("DeleteProduct", {
        id: item.id,
        merchantId: context.merchant?.id
    });

    return res;
}


export const ListProductPage = ItemListContent.builder<IProductListView, IListProduct>()

    .info({
        name: "product-list",
        route: "/product",       
        icon: Icons["product"]
    })

    .resource("Product")
     
    .options(()=> ({
        title: "product-list",
        style: ["panel", "round-item"],
        itemAddContent: CreateProductPage.factory,
        itemEditContent: item => content(EditProductPage, { id: item.id }),
        itemsSource: productItemsSource,
        prepareFilter: (filter, offset, limit) => ({
            ...filter,
            saleCircuitId: filter?.saleCircuitId ?? context.saleCircuit?.id,
            merchantId: filter?.merchantId ?? context.merchant?.id
        }),
        filterEditor: createFilter,
        confirmDeleteMessage: "msg-confirm-delete",
        deleteItemAsync: item => deleteItemAsync(item),
        pageSize: 50,
        emptyView: <EmptyView
            iconName="shopping_cart"
            message="msg-no-product"
        />,
        columns: [{
            value: a => a.name,
            priority: "primary",
            header: "name",
        }],
        editMode: "page",
        filterMode: "tags"

    }))
    .asContent();